import { useState as n, useEffect as c } from "react";
const s = (e) => {
  const [r, o] = n("Quorum"), t = (u) => {
    o(u), document.title = `${u} - Quorum`;
  };
  return c(() => (t(e), () => {
    document.title = "Quorum";
  }), [e]), { pageTitle: r, setPageTitle: t };
};
export {
  s as usePageTitle
};
